import common from './modules/common'
import home from './modules/home'
import news from './modules/news'
import notFound from './modules/notFound'
import tournaments from './modules/tournaments'
import joinUs from './modules/joinUs'
import partner from './modules/partner'
import information from './modules/information'
import tickets from './modules/tickets'
import servers from './modules/servers'
import footer from './modules/footer'
import sponsorPage from './modules/sponsorPage'


export default {
  common,
  home,
  news,
  notFound,
  tournaments,
  joinUs,
  partner,
  information,
  tickets,
  servers,
  footer,
  sponsorPage,
};
